export const environment = {
  production: false,
  baseUrl: "",
  baseApiUrl: "/api",
};
